module.exports = __webpack_public_path__ + "static/media/pabloVasquez.46e87189.jpg";